module.exports = {
	"1": "Asia/Astana",
	"2": "Europe/Moscow"
};


//////////////////
// WEBPACK FOOTER
// ./js/shared/dictionaries/timezones.json
// module id = 1823
// module chunks = 2